import ReactDOM from "react-dom/client";

import App from "./router";

import "../assets/global.css";
import "../assets/hamburger.css";

import { getFirebaseApp } from "@/lib/firebase";
import { reloadOnceForStaleChunk } from "@/lib/helpers/chunk-reload";
import { initHotjar } from "@/lib/monitoring/hotjar";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";
import { Sentry, init as SentryInit } from "@/lib/monitoring/sentry";
import { initRudder } from "@/lib/rudderstack/index.web";
import { getPlatform } from "@/lib/utils";

import { preventIosInputZoom } from "@luce/core/platform";

SentryInit();
Sentry.setTag("route.platform", getPlatform());

// A tab open during a deploy can request a chunk hash that no longer exists;
// reload once to pull the fresh build. lazyNamed covers the SPA-catchall path.
window.addEventListener("vite:preloadError", () => {
  reloadOnceForStaleChunk();
});

preventIosInputZoom();

getFirebaseApp();
initHotjar();
PosthogAnalytics.init();
initRudder();

const el = document.getElementById("root");

if (!el) {
  throw new Error("Unable to find root element");
}

ReactDOM.createRoot(el).render(<App />);
